<template>
  <div>
    <v-container fluid>
      <v-card>
        <v-app-bar color="primary" flat dark dense>
          <v-toolbar-title>Usuários</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn
            depressed
            fab
            small
            @click="tooglePesquisa"
            color="primary lighten-5"
          >
            <v-icon>search</v-icon>
          </v-btn>
        </v-app-bar>

        <v-expand-transition>
          <v-row dense v-show="exibirPesquisa" class="pa-2">
            <v-col cols="12" pa-2>
              <v-text-field
                ref="pesquisa"
                label="Pesquisa"
                v-model="pesquisa"
                prepend-inner-icon="search"
                solo
                background-color="grey lighten-2"
                clearable
                single-line
                hide-details
                placeholder="Pesquisa"
                color="primary"
                @click:clear="tooglePesquisa"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-expand-transition>

        <v-divider />

        <v-data-table
          :search="pesquisa"
          :headers="headers"
          :items="usuarios"
          :loading="loading"
          :footer-props="{
            itemsPerPageOptions: [10, 30, 50, { text: 'Todos', value: -1 }],
            itemsPerPageText: 'Registros Exibidos',
          }"
          :items-per-page="30"
          no-data-text="Sem registros"
          no-results-text="Sem registros"
          loading-text="Carregando dados..."
        >
          <template v-slot:items="{ item: usuario }">
            <td>
              {{
                usuario.administrador_nome ||
                  usuario.cliente_nome ||
                  usuario.fornecedor_nome ||
                  usuario.representante_nome
              }}
            </td>
          </template>
          <template v-slot:item.tipo="{ item }">
            <span style="text-transform: capitalize;">{{ item.tipo }}</span>
          </template>
          <template v-slot:item.verificado="{ item }">{{
            item.verificado ? "OK" : ""
          }}</template>
          <template v-slot:item.opcoes="{ item }">
            <v-btn fab depressed small @click="abrirDialogoResetar(item)">
              <v-icon>restart_alt</v-icon>
            </v-btn>
          </template>
        </v-data-table>
      </v-card>

      <as-dialogo
        ref="dialogoResetar"
        title="Resetar Senha"
        max-width="440px"
        hideCloseButton
        hideDivider
      >
        <v-label>Deseja resetar a senha deste usuario?</v-label>
        <br />
        <br />
        <v-label
          ><b>{{
            usuario.administrador_nome ||
              usuario.cliente_nome ||
              usuario.fornecedor_nome ||
              usuario.representante_nome
          }}</b></v-label
        >
        <br />
        <v-label>{{ usuario.email }}</v-label
        ><br />
        <span style="text-transform: capitalize;">{{ usuario.tipo }}</span>
        <br />
        <small style="color: red"
          >A senha será redefinida para <b>123456</b>!</small
        >
        <div slot="botoes">
          <v-btn
            depressed
            class="mr-4"
            :disabled="resetando"
            @click="$refs.dialogoResetar.fechar()"
            >Cancelar</v-btn
          >
          <v-btn
            depressed
            color="error"
            @click="resetar"
            :disabled="resetando"
            :loading="resetando"
            >Resetar</v-btn
          >
        </div>
      </as-dialogo>
    </v-container>
  </div>
</template>

<script>
import ServiceUsers from "@/services/users.js";
import config from "@/config";
import moment from "moment";

export default {
  name: "usuarios",
  data() {
    return {
      usuarios: [],
      loading: false,
      resetando: false,
      headers: [],
      pesquisa: "",
      exibirPesquisa: false,
      usuario: {},
    };
  },
  mounted() {
    this.headers = [
      { text: "Nome", value: "nome", width: "35%" },
      {
        text: "Email",
        value: "email",
        width: "40%",
      },
      { text: "Tipo", value: "tipo", width: "15%", align: "center" },
      {
        text: "Status",
        value: "verificado",
        width: "5%",
        sortable: false,
        align: "center",
      },
      {
        text: "",
        value: "opcoes",
        width: "5%",
        sortable: false,
        align: "center",
      },
    ];
    this.listar();
  },

  methods: {
    async listar() {
      try {
        this.loading = true;
        let response = await ServiceUsers.listarTodos();
        this.usuarios = response.data.usuarios;
      } catch (error) {
        this.$eventbus.error("Erro ao listar usuários");
      } finally {
        this.loading = false;
      }
    },
    abrirDialogoResetar(usuario) {
      this.usuario = this.clone(usuario);
      this.$refs.dialogoResetar.abrir();
    },
    tooglePesquisa() {
      this.exibirPesquisa = !this.exibirPesquisa;
      if (this.exibirPesquisa) {
        setTimeout(() => {
          this.$refs.pesquisa.focus();
        }, 0);
      }
    },
    async resetar() {
      try {
        this.resetando = true;
        await ServiceUsers.resetarSenha({ id: this.usuario.id });
        this.$eventbus.notificar("Senha resetada com sucesso");
      } catch (error) {
        this.$eventbus.erro("Erro ao resetar a senha deste fornecedor");
      } finally {
        this.resetando = false;
        this.$refs.dialogoResetar.fechar();
      }
    },
  },
};
</script>

<style scoped></style>
